import type { WhatsappChat } from "@stockline/shared/types/communications/whatsapp-chat"
import type { OfflineResourceConfig } from "../../../types"
import { WHATSAPP_CHAT_TABLE } from "./db"

export const whatsappChatConfig: OfflineResourceConfig<WhatsappChat> = {
  name: "whatsapp-chats",
  // Server visibility is GROUP-scoped: wiped + cold re-pulled on a
  // scope change (STK-1238).
  groupScoped: true,
  endpoints: {
    full: "/api/v2/whatsapp-chats",
    delta: "/api/v2/whatsapp-chats/changes",
    push: "/api/v2/whatsapp-chats/changes",
  },
  tableName: WHATSAPP_CHAT_TABLE,
  primaryKey: "id",
  indexes: {
    companyId: "companyId",
    instanceId: "instanceId",
    archived: "archived",
    enabled: "enabled",
    lastMessageDate: "lastMessageDate",
    syncId: "syncId",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
